/* eslint no-console: 0 */
/* eslint react-hooks/exhaustive-deps: 0 */
import React, { useEffect, useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { useLoading } from '../../../../../presentation/contexts/loading'
import { useMe } from '../../../../../presentation/contexts/me'
import { usePage } from '../../../../../presentation/contexts/page'
import { useSnackbar } from '../../../../../presentation/contexts/snackbar'
import ProfileEditor from '../../../../../presentation/pages/dashboard/configurations/profiles/editor'
import { theme } from '../../../../../presentation/styles/theme'
import { makePermission } from '../../../../usecases/permissions/load-permission-factory'
import { apiToFormik, makeProfile } from '../../../../usecases/profiles/load-profile-factory'

const MakeProfileEditor = () => {
  const { setHeader } = usePage()
  const { me } = useMe()
  const { setIsShowing, setText, setType } = useSnackbar()
  const { onSetLoading } = useLoading()
  const history = useHistory()
  const location = useLocation()
  const [initialProfile, setInitialProfile] = useState<any | null>(null)
  const [isToUpdate, setIsToUpdate] = useState<any>(null)
  const [permissionGroup, setPermissionGroup] = useState<any>([])

  const dataForm = [
    {
      items: [
        {
          title: 'Dados',
          subtitle: '',
          component: 'Title',
        },
        {
          name: 'name',
          component: 'Input',
          value: '',
          placeholder: 'Digite aqui',
          title: 'Nome',
          label: 'Nome',
          required: true,
          validations: 'inputRequired',
          styleContainer: { width: '32%', marginBottom: '30px' },
        },
        {
          name: 'description',
          component: 'Textarea',
          value: '',
          placeholder: 'Digite aqui',
          title: 'Descrição',
          label: 'Descrição',
          required: true,
          validations: 'inputRequired',
          styleContainer: { width: '32%', marginBottom: '30px' },
        },
        {
          title: 'Acessos do perfil',
          subtitle: '',
          component: 'Title',
        },
        {
          name: 'permissions',
          component: 'InputCheck',
          value: [],
          title: '',
          label: '',
          required: true,
          options: [...permissionGroup],
          containerStyle: { display: 'flex', flexDirection: 'column' },
          style: { margin: 0 },
          validations: 'arrayRequired',
        },
        {
          name: 'button',
          component: 'Button',
          title: 'Salvar',
          submittingText: 'Salvando...',
          style: { background: theme.colors.blue, width: '187px', marginTop: '45px' },
        },
      ],
    },
  ]

  const formattedPermissionsToSubmit = (permissions: any) => (
    permissions.map((permission: any) => JSON.parse(permission))
  )

  const onSubmit = async (values:any): Promise<void> => {
    const itemToSubmit = {
      name: values.name,
      description: values.description,
      permissions: formattedPermissionsToSubmit(values.permissions),
    }

    try {
      if (!me) return
      const stablishmentId = me.stablishments[0].id
      if (isToUpdate) {
        await makeProfile(stablishmentId).patch(isToUpdate.id, itemToSubmit)
      } else {
        await makeProfile(stablishmentId).post(itemToSubmit)
      }

      setType('success')
      setText('Salvo com sucesso!')
      setIsShowing(true)
      history.push('/dashboard/profiles')
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    (async () => {
      const { item } = location.state as any
      onSetLoading(true)
      setHeader({
        title: item ? 'Editar Perfil' : 'Novo Perfil',
        goTo: '/dashboard/profiles',
      })

      if (item) {
        const data = apiToFormik({ ...item })
        setInitialProfile({ ...data })
        setIsToUpdate(item)
      }

      const { permissions } = await makePermission().load()
      const formattedPermissions = permissions.map((permission: any) => ({
        label: permission.name,
        value: JSON.stringify(permission),
      }))
      setPermissionGroup(formattedPermissions)
      onSetLoading(false)
    })()
  }, [setHeader, location.state])

  return (
    <ProfileEditor
      initialData={initialProfile}
      dataForm={dataForm}
      onSubmit={onSubmit}
    />
  )
}

export default MakeProfileEditor
